import { post, get, baseURL } from "@/utils/request";

export const getMisteryGift = (data: any) => post(`/activity/pickMysteryGift`, data);